module.exports = __webpack_public_path__ + "img/calendar.6d93eba7.svg";